/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import { createSelector } from 'reselect';
import { getOrderTotalBalance } from '../../Cart/Cart-Selectors';

const getGiftCards = (state) => state.mfeCheckout?.cart?.appliedGiftCards;

export const getGiftCardDiscounts = createSelector(
    [getGiftCards],
    (giftCards) => {
        if (giftCards && giftCards.length > 0) {
            let result = giftCards.reduce((sum, { amount }) => sum + parseFloat(amount), 0);
            result = result.toString();

            if (result.indexOf('.') === -1) {
                result += '.00';
                return Number(result);
            }

            return Number(result)?.toFixed(2);
        }

        return Number('0.00');
    },
);

export const getIsGiftCardCoverFullOrderTotal = createSelector(
    [getOrderTotalBalance], (orderTotalBalance) => {
        if (orderTotalBalance && Number(orderTotalBalance) === 0) {
            return true;
        }

        return false;
    },
);

export default {};
